/**
 * Fetch a single interview by ID.
 * GET /api_ats/v1/ats_interviews/:id
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/request';
import type { InterviewDetails } from './interviews.types';

export function fetchInterview(interviewId: number): Promise<InterviewDetails> {
  // Default unwrapData=true pulls the payload out of `{ data: ... }`
  // when the runtime wraps it; when the body is already flat it
  // passes through unchanged.
  return api.get<InterviewDetails>(`ats_interviews/${interviewId}`);
}

export function useGetInterview(
  interviewId: number | undefined,
  options?: { enabled?: boolean }
) {
  return useQuery<InterviewDetails, Error>({
    queryKey: ['schedule-interview', 'detail', interviewId],
    queryFn: () => fetchInterview(interviewId!),
    enabled: (options?.enabled ?? true) && interviewId !== undefined,
    staleTime: 60_000,
  });
}
